import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import * as VoucherActions from '../actions/voucher.actions';
import { Voucher } from '../../interfaces/voucher';

export const featureKey = 'vouchers';

/**
 * @ngrx/entity provides a predefined interface for handling
 * a structured dictionary of records. This interface
 * includes an array of ids, and a dictionary of the provided
 * model type by id. This interface is extended to include
 * any additional interface properties.
 */
export interface State extends EntityState<any> {
  loading: boolean;
  error: string;
}

/**
 * createEntityAdapter creates an object of many helper
 * functions for single or multiple operations
 * against the dictionary of records. The configuration
 * object takes a record id selector function and
 * a sortComparer option which is set to a compare
 * function if the records are to be sorted.
 */
export const adapter: EntityAdapter<Voucher> = createEntityAdapter<Voucher>({
  selectId: (voucher: any) => voucher.id,
  sortComparer: false,
});

/**
 * getInitialState returns the default initial state
 * for the generated entity state. Initial state
 * additional properties can also be defined.
 */
export const initialState: State = adapter.getInitialState({
  loading: false,
  error: null,
});

export const reducer = createReducer(
  initialState,
  on(VoucherActions.retrieve, (state) => ({...state, loading: true})),
  on(VoucherActions.retrieveSuccess, (state, {vouchers}) => adapter.setAll(vouchers, state)),
  on(VoucherActions.retrieveSuccess, (state) => ({...state, loading: false, error: null})),
  on(VoucherActions.retrieveFailure, (state, {error}) => ({...state, error}))
);
